<div class="d-flex">
	<div class="display-6 ms-1 mt-2 mb-1">Automatic Employee Messages</div>
	<div class="ms-auto">
		<app-record-control-footer
			[hideAdd]="false"
			[hideCancel]="true"
			[hideDelete]="true"
			[hideSave]="true"
			(onAddChange)="new()"
		></app-record-control-footer>
	</div>
</div>
<small class="p-text-secondary">
	Automatic Employee Messages allow you to automatically send messages to your employees based on the job they're working, and the hours they've worked in a
	single shift.
</small>
<p-divider></p-divider>
<app-automatic-employee-message-list></app-automatic-employee-message-list>
